
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'report-double': {
    width: 15,
    height: 18.2,
    viewBox: '0 0 15 18.2',
    data: '<path pid="0" d="M14.8 5.1L9.9.1c-.1 0-.2-.1-.4-.1H3.6c-.2 0-.5.2-.5.5v2.4H.5c-.3 0-.5.2-.5.5v14.3c0 .3.2.5.5.5h10.8c.3 0 .5-.2.5-.5v-2.4h2.6c.3 0 .5-.2.5-.5V5.5c.1-.1 0-.3-.1-.4zM1 17.2V3.9h5.2l4.6 4.7v8.6H1zm13-2.9h-2.1V8.4c0-.1-.1-.3-.1-.4l-5-5c-.1 0-.3-.1-.4-.1H4.1V1h5.2L14 5.7v8.6z" _fill="#8390a0"/>'
  }
})
